import { Button, Tooltip, Divider, Col, Card } from 'antd'
import {
    IdcardOutlined,
    MedicineBoxOutlined,
    GiftOutlined,
    UserOutlined,
    EnvironmentOutlined,
    HomeOutlined,
    MailOutlined,
    InstagramOutlined,
    TwitterOutlined,
    FacebookOutlined,
    LinkedinOutlined
} from '@ant-design/icons'
import { fadeInLeft } from 'react-animations'
import styled, { keyframes } from 'styled-components'

import profile from '../images/profile.jpg'


const fadeInLeftAnimation = keyframes`${fadeInLeft}`
const FadeInLeftCard = styled(Card)`
  animation: 1s ${fadeInLeftAnimation}
`
const ProfileInfo = styled.p`
  font-size: 16px;
`
const ContactIconContainer = styled.div`
  display: flex;
  justify-content: space-between;

  a:hover {
    color: #2196f3 !important;
  }
`

export default function Profile() {

    return <Col xs={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xxl={{ span: 6 }}>
        <FadeInLeftCard className='black-card' style={{ backgroundColor: '#212121' }} bordered={false}>
            <Tooltip title={<p>🇹🇭 In Thai Alphabet: ภัทร ไตรรัตน์ (Native)<br />🇰🇷 In Korean Alphabet: 팟타라 따이랏</p>}>
                <h1 style={{ textAlign: 'center' }}>PATARA TRIRAT (태현준)</h1>
            </Tooltip>
            <div style={{ paddingLeft: 36, paddingRight: 36, textAlign: 'center' }}>
                <img alt='profile' src={profile} style={{ maxWidth: 256 }} width="100%" />
            </div>
            <Divider style={{ color: '#e91e63', borderBlockStart: 'white' }}>MOTTO</Divider>
            <p style={{ textAlign: 'center' }}>NEVER GIVE UP <br /> <small><i>"There is nothing that perseverance cannot win"</i></small> <br /> 초부득삼 x 칠전팔기</p>
            <Divider style={{ color: '#4caf50', borderBlockStart: 'white' }}> PERSONAL INFO</Divider>
            <ProfileInfo><IdcardOutlined /> THAI</ProfileInfo>
            <ProfileInfo><MedicineBoxOutlined /> B</ProfileInfo>
            <ProfileInfo><GiftOutlined /> 1994.05.16</ProfileInfo>
            <ProfileInfo><UserOutlined /> 174 CM - 68 KG</ProfileInfo>
            <ProfileInfo><EnvironmentOutlined /> KAIST E3-1 Bld., Room #2442</ProfileInfo>
            <ProfileInfo><HomeOutlined /> Daejeon, South Korea</ProfileInfo>
            <Divider style={{ color: '#2196f3', borderBlockStart: 'white' }}>CONTACT</Divider>
            <ContactIconContainer>
                <Tooltip title='patara.t@kaist.ac.kr'>
                    <a target="blank" href='mailto:patara.t@kaist.ac.kr' style={{ fontSize: 32 }}><MailOutlined /></a>
                </Tooltip>
                <Tooltip title='itouchz'>
                    <a target="blank" href='https://www.linkedin.com/in/itouchz/' style={{ fontSize: 32 }}><LinkedinOutlined /></a>
                </Tooltip>
                <Tooltip title='itouchz.me'>
                    <a target="blank" href='https://www.facebook.com/itouchz.me' style={{ fontSize: 32 }}><FacebookOutlined /></a>
                </Tooltip>
                <Tooltip title='@itouchz.me'>
                    <a target="blank" href='https://www.instagram.com/itouchz.me' style={{ fontSize: 32 }}><InstagramOutlined /></a>
                </Tooltip>
                <Tooltip title='@itouchz_me'>
                    <a target="blank" href='https://www.twitter.com/itouchz_me' style={{ fontSize: 32 }}><TwitterOutlined /></a>
                </Tooltip>
            </ContactIconContainer>
            <br />
            <Button block type='primary' href='files/cv.pdf' target='_blank'>Curriculum Vitae</Button>
        </FadeInLeftCard>
    </Col>
}